import {makeAutoObservable} from 'mobx';

export type ToastSeverity = 'success' | 'error' | 'warning' | 'info';

export interface ToastDetail {
    message: string;
    severity: ToastSeverity;
    duration?: number;
}

interface ToastInstance extends ToastDetail {
    timestamp: number;
}

class ToastStore {
    currentToast: ToastInstance | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    showToast(detail: ToastDetail) {
        this.currentToast = {
            ...detail,
            timestamp: Date.now(),
        };
    }

    clearToast() {
        this.currentToast = null;
    }
}

export const toastStore = new ToastStore();
